import script from "./infinite-scroll.vue?vue&type=script&setup=true&lang=js"
export * from "./infinite-scroll.vue?vue&type=script&setup=true&lang=js"

import "./infinite-scroll.vue?vue&type=style&index=0&id=403915d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403915d4"]])

export default __exports__